import React from 'react';
import { List } from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';

import './style.scss';
import { TitleHeaderBlock } from '../../../components';

const ParagraphThreeTeasers = ({ entity }) => {

  const title = entity.getIn(['field_title', 0, 'value'], false);
  return (
    <div className="ThreeTeasers">
      { title && (
        <TitleHeaderBlock
          title={title}
        />
      )}
      <div className="row no-gutters">
        {entity.get('field_paragraphs') ? (
          entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <div className="col-12 col-md-4 ThreeTeasers__item" key={`paragraph:${id}:${language}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </div>
            );
          })
        ) : null}
      </div>
    </div>
  );
};

export default ParagraphThreeTeasers;
